import { Box, Typography } from "@mui/material";
import CustomProfil from "../../Common/CustomProfil/CustomProfil";
import CustomToggleChipGroup from "../../UIElements/CustomToggleChipGroup";
import { TabMenu } from "@/src/types";
import { SyntheticEvent } from "react";

type DocumentsLayoutHeaderProps = {
    headerTitle: string;
    numberOfDocs: number;
    tabsMenu: TabMenu[];
    setActiveTab: Function;
    activeTab: string;
};

export default function DocumentsLayoutHeader({
    headerTitle,
    numberOfDocs,
    tabsMenu,
    activeTab,
    setActiveTab,
}: DocumentsLayoutHeaderProps) {
    return (
        <Box
            sx={{
                marginLeft: "6rem",
                marginTop: "5vh",
                marginRight: "1.5rem",
                marginBottom: "2rem",
                display: "flex",
                flexDirection: "column",
                gap: "2.28rem",
                "@media (max-width:1024px)": {
                    marginLeft: "1.5rem",
                },
            }}
        >
            <Box>
                <CustomProfil />
            </Box>

            <Box
                sx={{
                    gap: "1.5rem",
                    display: "inline-flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                }}
            >
                <Box
                    sx={{
                        gap: "2rem",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",
                    }}
                >
                    <Box
                        sx={{
                            gap: "1.5rem",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "flex-start",
                        }}
                    >
                        <Box
                            sx={{
                                gap: "0.5rem",
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "flex-start",
                            }}
                        >
                            <Typography
                                sx={{
                                    color: "#005499",

                                    fontFamily: "Roboto",
                                    fontSize: "1.75rem",
                                    fontStyle: "normal",
                                    fontWeight: "500",
                                    lineHeight: "normal",
                                }}
                            >
                                Mes documents
                            </Typography>
                            <Typography
                                sx={{
                                    color: "#023",

                                    fontFamily: "Roboto",
                                    fontSize: "1.125rem",
                                    fontStyle: "normal",
                                    fontWeight: "400",
                                    lineHeight: "1.25rem",
                                }}
                            >
                                {headerTitle}
                            </Typography>
                        </Box>
                        <Box
                            sx={{
                                height: "0.125rem",
                                alignSelf: "stretch",
                                background: "#E3E6E8",
                            }}
                        ></Box>
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "flex-start",
                                gap: "16.6875rem",
                            }}
                        >
                            <CustomToggleChipGroup
                                active={activeTab}
                                handleChange={(e: SyntheticEvent, value: any) =>
                                    setActiveTab(value)
                                }
                                tabsMenu={tabsMenu}
                            />
                        </Box>
                    </Box>
                </Box>
            </Box>

            <Typography
                sx={{
                    color: "#023",

                    fontFamily: "Roboto",
                    fontSize: "0.875rem",
                    fontStyle: "normal",
                    fontWeight: "500",
                    lineHeight: "normal",
                }}
            >
                {`${numberOfDocs} document(s)`}
            </Typography>
        </Box>
    );
}
